import React from "react";
import Utils from '../Utils';
import {__APIKCURL__} from '../../consts/consts';
import Storage from '../Storage';
import ReactPlayer from 'react-player';
import './style.css';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import Carousel from 'react-bootstrap/Carousel';
import IntlMessages from '../../helpers/IntlMessages'
import ApiCalls from "../ApiCalls";


class SponsorCarousel extends React.Component {

    constructor(props){
        super(props);
       this.state={isLoading:true,data:null}
    }
  
    componentDidMount(){
        ApiCalls.getSponsorsData().then(response=>{
            let stands = Storage.getStands();
            let sponsors = response.data.sort((a, b) => a.categoryOrder - b.categoryOrder || a.orderInCategory - b.orderInCategory)
            .filter(o => o.showInCarousel == true && o.deleted == 0).map(result => {
                return {
                    id: result.id,
                    icon: Utils.getPictureOrTransparent(result.pictureId),
                    standUrl: stands.find(s => s.exhibitorName == result.name) != null ? stands.find(s => s.exhibitorName == result.name).exhibitorName : ''
                };
            });
            this.setState({ data: sponsors, isLoading: false })
        })
    }
    onImageClick(ev){

        if (ev.currentTarget.attributes.standurl.value != null && ev.currentTarget.attributes.standurl.value != '')
            this.props.history.push({pathname:"/fair/stand/"+encodeURI(ev.currentTarget.attributes.standurl.value ) });

    }
    render() {
        if (this.state.isLoading)
            return (<h2><IntlMessages id="dashboards.loading"/></h2>) 
        return (
                <div id="CarouselContainer" className={this.props.className}>
                    <Carousel>
                    {this.state.data.map((item, index) => {
                        return (
                        <Carousel.Item key={item.id} id={"SponsorCarouselItem_"+item.id}>

                            <img
                            className="d-block "
                            src={item.icon}
                            standurl={item.standUrl}
                            onClick={(ev)=>this.onImageClick(ev)}
                            />

                        </Carousel.Item>
                        );
                        })}
                   </Carousel>
                    </div>
        );
    }
}

export default withRouter(SponsorCarousel);